import React from 'react';
import Solution from '../../assets/images/solution/new/solution.png';
import Consultation from '../../assets/images/solution/new/consultation.png';
import Experience from '../../assets/images/solution/new/experience.png';
import Analitic from '../../assets/images/solution/new/analitic.png';
import Integration from '../../assets/images/solution/new/Integration.png';
import FAQ from '../../components/Home/FAQ';

const AiSolution = () => {
  return (
    <div className='pt-28'>
      <section className='h-full px-8 sm:px-10 xl:px-0 max-w-[1200px] m-auto w-full py-16 sm:py-20 flex flex-col gap-24 md:gap-40'>
        <div className='flex flex-col md:flex-row items-center gap-12 '>
          <div className='flex flex-col gap-8'>
            <p className='font-bold text-2xl sm:text-4xl'>
              Solusi AI: Merevolusi Pemecahan Masalah dengan Kecerdasan Buatan
            </p>
            <p className='text-base sm:text-xl'>
              Kami ahli dalam menciptakan sistem cerdas yang mengintegrasikan
              teknologi AI secara mulus untuk meningkatkan efisiensi,
              pengambilan keputusan, dan pengalaman pelanggan.
            </p>
          </div>
          <img src={Solution} alt={'AiSolution1'} />
        </div>

        <div className='flex flex-col md:flex-row-reverse items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Analitik Data & Wawasan
            </p>
            <p className=''>
              Manfaatkan potensi penuh data Anda dengan layanan analitik canggih
              kami. Kami memberikan wawasan mendalam yang mendukung keputusan
              strategis, membantu Anda tetap unggul dalam persaingan dengan cara
              yang aman dan sesuai regulasi.
            </p>
          </div>

          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={Analitic} alt={'AiSolution2'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Strategi & Konsultasi AI
            </p>
            <p className=''>
              Kami membantu Anda menghadapi tantangan penerapan AI. Layanan
              konsultasi kami berfokus pada penyusunan strategi AI yang jelas,
              mengidentifikasi peluang, dan menciptakan peta jalan yang selaras
              dengan tujuan bisnis Anda, sambil memastikan kepatuhan terhadap
              standar industri.
            </p>
          </div>

          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={Consultation} alt={'AiSolution3'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row-reverse items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Peningkatan Pengalaman Pelanggan Berbasis AI
            </p>
            <p className=''>
              Tingkatkan pengalaman pelanggan dengan solusi AI yang menghadirkan
              layanan personal, responsif, dan proaktif. Solusi kami membantu
              membangun hubungan yang lebih kuat dengan pelanggan dan
              meningkatkan loyalitas mereka.
            </p>
          </div>

          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={Experience} alt={'AiSolution4'} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row items-center gap-12 '>
          <div className='flex flex-col gap-4 sm:p-10 w-full max-w-[666px]'>
            <p className='font-bold text-2xl sm:text-3xl'>
              Integrasi Pembelajaran Mesin
            </p>
            <p className=''>
              Manfaatkan kekuatan pembelajaran mesin untuk mengubah data menjadi
              wawasan yang dapat ditindaklanjuti. Solusi kami dirancang untuk
              terus belajar dan beradaptasi, mendukung keputusan yang lebih
              cerdas dan inovasi, dengan tetap menjaga protokol keamanan yang
              ketat.
            </p>
          </div>

          <div className='w-full max-w-[450px] max-h-[450px] p-4 bg-[#F7F7F7] rounded-md'>
            <img src={Integration} alt={'AiSolution5'} />
          </div>
        </div>

        <div className='flex flex-col items-center sm:p-10 w-full max-w-[666px]-center gap-10'>
          <p className='font-bold text-2xl sm:text-3xl'>Alur Kerja Kami</p>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 justify-between gap-12 sm:gap-6 bg-[#F7F7F7] p-8 md:p-12 '>
            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Konsultasi</p>
              <p className='text-[#898989]'>
                Kami memulai dengan memahami tantangan bisnis Anda dan
                mengidentifikasi area di mana AI dapat memberikan dampak yang
                signifikan.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Desain Solusi Khusus</p>
              <p className='text-[#898989]'>
                Tim ahli kami merancang solusi AI yang dibuat khusus, dirancang
                untuk terintegrasi dengan mulus ke dalam sistem yang sudah Anda
                miliki.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Penerapan & Integrasi</p>
              <p className='text-[#898989]'>
                Kami memastikan implementasi berjalan lancar dan memberikan
                dukungan selama masa transisi.
              </p>
            </div>

            <div className='flex flex-col gap-2 '>
              <p className='text-2xl font-bold'>Dukungan Berkelanjutan</p>
              <p className='text-[#898989]'>
                Setelah peluncuran, kami menyediakan layanan pemeliharaan,
                pembaruan, dan optimasi untuk memastikan solusi AI Anda terus
                memberikan nilai maksimal.
              </p>
            </div>
          </div>
        </div>
        {/* <div className="py-24">
                    <FAQ />
                </div> */}
      </section>
    </div>
  );
};

export default AiSolution;
